<template>
<div class="out-bg">
  <div class="resource-center-container" ref="containerRef" v-if="loading">
    <div v-if="loaded && menuList.length === 0" class="page-no-data">
      <!-- <div class="page-no-data-main">
        <div class="no-content">
          <img
            width="314"
            src="@/assets/image/empty@3x.png"
            class="load-more-icon"
            alt=""
          />
          <div class="txt">暂无内容</div>
        </div>
      </div> -->

      <empty :content="emptyText" :showBtn="certifiedStatus" />
    </div>

    <template v-else>
      <document-nav
        :menuList="menuList"
        :activeId="curFirstLevel.id"
        :showSearch="false"
        @handleClick="handleClickMenu"
      ></document-nav>

      <div class="resource-main">
        <div class="left-catelog">
          <div class="main-title font-bold">{{$t('document.documentDirectory')}}</div>
          <div class="catelog-main">
            <el-tree
              :empty-text="$t('document.nodata')"
              node-key="id"
              :current-node-key="currentNodeKey"
              :default-expanded-keys="defaultExpanded"
              :data="treeData"
              :props="defaultProps"
              highlight-current
              @node-click="handleNodeClick"
            />
          </div>
        </div>
        <div
          v-if="currentNodeKey === -1 || currentNodeKey === -2"
          class="resource-content-download"
        >
          <resource-download :resourceList="resourceList" />
          <update-logs :logList="logList" :isLoading="logIsLoading" />
        </div>

        <template v-else>
          <div
            v-if="loaded && !currentdetail.title"
            class="resource-no-content"
          >
            <div class="no-content">
              <img
                width="314"
                src="@/assets/image/empty@3x.png"
                class="load-more-icon"
                alt=""
              />
              <div class="txt">{{$t('document.noContent')}}</div>
            </div>
          </div>
          <template v-else>
            <div class="resource-content">
              <div class="main">
                <div v-if="currentdetail.title" class="document-content">
                  <div class="breadcrumbs">
                    <span
                      class="crumbs-item crumbs-active des_one_row"
                      @click="clickBreadcrumbs(1)"
                    >
                      {{ curFirstLevel.projectName }}
                    </span>
                    <template v-if="curSecondLevel.title">
                      <img
                        src="@/assets/image/icon/next-blue.png"
                        alt=""
                        class="next-btn"
                      />
                      <span
                        class="crumbs-item crumbs-active des_one_row"
                        @click="clickBreadcrumbs(2)"
                      >
                        {{ curSecondLevel.title }}
                      </span>
                    </template>
                    <template v-if="currentdetail.title">
                      <img
                        src="@/assets/image/icon/next-gray.png"
                        alt=""
                        class="next-btn"
                      />
                      <span class="crumbs-item des_one_row">
                        {{ stripHtmlTags(currentdetail.title) }}
                      </span>
                    </template>
                  </div>
                  <div
                    v-if="currentdetail.title"
                    class="document-title font-bold"
                    v-html="currentdetail.title"
                  ></div>
                  <div v-if="currentdetail.updateTime" class="create-time">
                    <img src="@/assets/image/icon/time.png" alt="" />
                    <span class="times"
                      >{{$t('document.updateTime')}}：{{ currentdetail.updateTime }}</span
                    >
                  </div>
                  <div
                    id="documentContent"
                    class="documnet-content language-"
                    v-html="sanitizedHtml"
                    @click="getImg"
                  ></div>
                </div>

                <template
                  v-if="
                    loaded &&
                    curSecondLevel?.children &&
                    curSecondLevel?.children.length > 0
                  "
                >
                  <!-- 分页 -->
                  <cm-pagination
                    :previousdetail="previousdetail"
                    :nextdetail="nextdetail"
                    @toPrePage="toNextPage(previousdetail)"
                    @toNextPage="toNextPage(nextdetail)"
                  ></cm-pagination>
                </template>
              </div>
            </div>
            <div class="right-navigation-wrap">
              <div v-if="contentNav.length > 0" class="right-navigation">
                <div class="main-title font-bold">{{$t('document.pageGuide')}}</div> 
                <div class="navigation-wrap" id="docNav">
                  <ul class="level1">
                    <li
                      :class="[
                        'nav-item',
                        'level1-item',
                        activeId === level1.id ? 'active-nav' : '',
                      ]"
                      v-for="(level1, index) in contentNav"
                      :key="index"
                    >
                      <a
                        :class="[
                          'level1-title', 'des_four_row',
                          'font-bold',
                          browsePosition === level1.domId ? 'active-nav' : '',
                        ]"
                        @click="setScrollPosition($event, level1)"
                        v-html="level1.title"
                      >
                      </a>
                      <ul
                        class="level2"
                        v-if="level1.children && level1.children.length > 0"
                      >
                        <li
                          class="nav-item level2-item"
                          v-for="(level2, index) in level1.children"
                          :key="index"
                        >
                          <a
                            :class="[
                              'level2-title','des_four_row',
                              browsePosition === level2.domId
                                ? 'active-nav'
                                : '',
                            ]"
                            @click="setScrollPosition($event, level2)"
                            v-html="level2.title"
                          >
                          </a>
                          <ul
                            class="level3"
                            v-if="level2.children && level2.children.length > 0"
                          >
                            <li
                              class="nav-item level3-item"
                              v-for="(level3, index) in level2.children"
                              :key="index"
                            >
                              <a
                                :class="[
                                  'level3-title',
                                  browsePosition === level3.domId
                                    ? 'active-nav'
                                    : '',
                                ]"
                                @click="setScrollPosition($event, level3)"
                                v-html="level3.title"
                              >
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </template>
    <preview-img ref="previewImgRef" />
  </div>
</div>
</template>

<script setup>
import previewImg from "@/components/previewImg";
import documentNav from "@/components/documentNav";
import empty from "@/components/empty";
import {getMyInfoApi} from "@/api/control";
import {
  resourceCenter,
  resourceSubMenu,
  resourceDetail,
} from "@/api/developer";
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  renderSlot,
  reactive,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import prism from "prismjs";

// Add numbering to the Code blocks
import "prismjs/plugins/line-numbers/prism-line-numbers.js";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/plugins/toolbar/prism-toolbar.js";
import "prismjs/plugins/toolbar/prism-toolbar.css";
import "prismjs/plugins/custom-class/prism-custom-class";
import "@/utils/prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.js";
import "@/utils/prismjs/themes/custom.css";
import resourceDownload from "./components/resourceDownload.vue";
import updateLogs from "./components/updateLogs.vue";
import cmPagination from "./components/cmPagination.vue";
import DOMPurify from "dompurify";
import { getUrlParms, stripHtmlTags } from "@/utils";
import { setElementId } from "@/utils/document";
import { useI18n } from "vue-i18n";
const { locale, t } = useI18n();

import {
  getResProjectListApi,
  getResListApi,
  getResCatalogListApi,
  getResLogApi,
} from "@/api/developer";

const defaultProps = {
  children: "children",
  label: "title",
};
const router = useRouter();
const route = useRoute();
const previewImgRef = ref(null);
const resourceList = ref([]);
const logList = ref([]);
const projectCatalog = ref([]);
const treeData = ref([]);
const curFirstLevel = ref({}); // 选中的一级菜单
const curSecondLevel = ref({}); // 选中的二级菜单
const menuList = ref([]);
const defaultExpanded = ref([]);
const currentNodeKey = ref("");
const documentId = ref("");
const currentdetail = ref({});
const contentNav = ref([]);
const activeId = ref(0);
const hDomIdList = ref([]);
const nextdetail = ref({});
const previousdetail = ref({});
const browsePosition = ref("heading_0"); // 浏览位置
const loaded = ref(false);
const scrollTimeout = ref(null);
const sanitizeConfig = {
  ADD_ATTR: ["target"],
};
const sanitizedHtml = computed(() => {
  return DOMPurify.sanitize(currentdetail.value.contentDetail, sanitizeConfig);
});

const resourceMenuObj = { id: -1, title: t("download.resourceDownloads") }; 
const logMenuObj = { id: -2, title: t("download.updateLog") }; 
const logPagnation = reactive({
  limit: 1,
  offset: 10,
});
const containerRef = ref(null);
const canLoadLogData = ref(false);
const logIsLoading = ref(0);
const certifiedStatus = ref(false);
const emptyText = ref(t("document.noContent"))
const loading = ref(false);

// 监听滚动
const handleScroll = (e) => {
  if (currentNodeKey.value < 0) {
    const container = containerRef.value;
    const browserHeight = window.innerHeight;
    const windowScrollHeight =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (browserHeight + windowScrollHeight > container.offsetHeight + 40) {
      if (!canLoadLogData.value) return;
      logPagnation.limit += 1;
      logIsLoading.value = 1;
      getResLogList();
    }
    return;
  }
  if (!currentdetail.value.contentDetail) return;
  if (!contentNav.value.length) return;
  let activeHeadingId = null;
  hDomIdList.value.forEach((nav) => {
    const hel = document.getElementById(nav.domId);
    if (nav.domId === "heading_0" && hel.getBoundingClientRect().top > 0) {
      activeHeadingId = "heading_0";
    } else if (hel.getBoundingClientRect().top <= 10) {
      activeHeadingId = nav.domId;
    }
  });

  if (activeHeadingId) {
    browsePosition.value = activeHeadingId;
    const docNavBox = document.getElementById("docNav");
    const activeNav = docNavBox.getElementsByClassName("active-nav")[0];
    const navHeight = docNavBox.offsetHeight; // 导读总高度
    const activeTop = activeNav.offsetTop; // 选中栏距离顶部的距离
    if (activeTop - 20 > navHeight) {
      docNavBox.scrollTop = activeTop - 130;
    } else {
      docNavBox.scrollTop = 0;
    }
  }
};

// 获取当前用户认证状态
const getMyInfo = () => {
  getMyInfoApi().then(res => {
    if(res.result.authenticationResult === 2100 || res.result.authenticationResult === 2300 || res.result.authenticationResult === 2400){
      if(res.result.authenticationResult === 2400){
        emptyText.value = t("download.noProjectTips")  
      }else{
        certifiedStatus.value = true
      }

      loaded.value = true;
      loading.value = true;
    }else{
      getResProjectList()
    }
    
  }).catch(err => { console.log(err); })
};

// 获取项目列表
const getResProjectList = () => {
  getResProjectListApi().then((res) => {
    if (res.code === 200) {
      if (res.result.length > 0) {
        menuList.value = res.result;
        const menuId = Number(getUrlParms("menuId"));
        if (menuId) {
          curFirstLevel.value =
            menuList.value.find((item) => item.id === menuId) || res.result[0];
        } else {
          curFirstLevel.value = res.result[0];
        }
        logList.value = [];
        logPagnation.limit = 1;
        getProjectMenu(); 
        loading.value = true;
      } else {
        emptyText.value = t("download.noProjectTips")
        loaded.value = true;
        loading.value = true;
        // router.replace({
        //   path: "/downloads",
        // });
      }
    }
  });
};

// 获取资源列表
const resList = () => {
  resourceList.value = [];
  return new Promise((resolve, reject) => {
    getResListApi({
      projectId: curFirstLevel.value.id,
    })
      .then((res) => {
        if (res.code === 200) {
          resourceList.value = res.result;
          resolve();
        }
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取日志列表
const getResLogList = () => {
  canLoadLogData.value = false;
  return new Promise((resolve, reject) => {
    getResLogApi({
      projectId: curFirstLevel.value.id,
      limit: logPagnation.limit,
      offset: logPagnation.offset,
    })
      .then((res) => {
        logIsLoading.value = 0;
        if (res.code === 200) {
          logPagnation.count = res.result.count;
          logList.value = [...logList.value, ...res.result.data];
          if (logList.value.length < res.result.count) {
            canLoadLogData.value = true;
          }
          resolve();
        }
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取资源下载目录树
const getResCatalogList = () => {
  projectCatalog.value = [];
  return new Promise((resolve, reject) => {
    getResCatalogListApi({ projectId: curFirstLevel.value.id })
      .then((res) => {
        if (res.code === 200) {
          projectCatalog.value = res.result;
          const level2 = [...res.result].find(
            (item) => item.id === Number(getUrlParms("submenuId"))
          );

          curSecondLevel.value = level2 || res.result[0];
          resolve();
        }
      })
      .catch(() => {
        reject();
      });
  });
};

// 获取左侧目录(全)
const getProjectMenu = () => {
  let submenuId= '',docId = '';
  treeData.value = [];
  Promise.all([resList(), getResLogList(), getResCatalogList()]).then(() => {
    let list = [];
    if (resourceList.value.length > 0) {
      list.push(resourceMenuObj);
    }
    if (logList.value.length > 0) {
      list.push(logMenuObj);
    }
    if (projectCatalog.value.length > 0) {
      list = [...list, ...projectCatalog.value];
      if(route.query.showArticle === 'true' && projectCatalog.value[0].children && projectCatalog.value[0].children.length > 0){
        submenuId = projectCatalog.value[0].id
        docId = projectCatalog.value[0].children[0].id

      }
    }
    
    treeData.value = list;

    getDefaultDoc(submenuId,docId);
    
  });
};

// 点击项目菜单
const handleClickMenu = (data) => {
  if (data.id === Number(getUrlParms("menuId"))) return;
  loaded.value = false;

  router.replace({
    path: "/downloads",
    query: {
      menuId: data.id,
    },
  });

  curFirstLevel.value = data;
  currentNodeKey.value = "";
  logList.value = [];
  logPagnation.limit = 1;
  resetDocData();
  getProjectMenu();
  
};

// 获取目录下的第一篇文档
const getDefaultDoc = (submId,dId) => {
  const submenuId = submId || Number(getUrlParms("submenuId"));
  const docId = dId || Number(getUrlParms("docId"));
  // 没有submenuId 或 submenuId为资源下载-1或更新日志-2
  if (!submenuId || submenuId === -1 || submenuId === -2) {
    if (resourceList.value.length > 0) {
      currentNodeKey.value = -1;
    } else if (logList.value.length > 0) {
      currentNodeKey.value = -2;
    } else {
      currentNodeKey.value = curSecondLevel.value.id;
    }
    loaded.value = true;
  } else {
    if (curSecondLevel.value.children.length > 0) {
      const level3 = curSecondLevel.value.children.find(
        (item) => item.id === docId
      );
      documentId.value = level3?.id || curSecondLevel.value.children[0].id;
      defaultExpanded.value = [documentId.value];
      currentNodeKey.value = documentId.value;
      getdocumentDeatail();
    } else {
      currentNodeKey.value = curSecondLevel.value.id;
      loaded.value = true;
    }
  }
};

// 点击左侧目录标题
const handleNodeClick = (data) => {
  // 文档id
  if (data.id > 0 && data.documentDirectoryId > 0) {
    documentId.value = data.id;
    getdocumentDeatail();
    // 给面包屑设置二级数据
    treeData.value.forEach((item) => {
      if (item.children && item.children.length > 0) {
        item.children.forEach((item2) => {
          if (item2.id === data.id) {
            curSecondLevel.value = item;
          }
        });
      }
    });
    router.replace({
      path: "/downloads",
      query: {
        menuId: curFirstLevel.value.id,
        submenuId: data.documentDirectoryId,
        docId: data.id,
      },
    });
    return;
  }

  // 对目录下有文章的不做处理
  if (data.id && data.children?.length > 0) {
    return;
  }

  resetDocData();
  currentNodeKey.value = data.id;
  router.replace({
    path: "/downloads",
    query: {
      menuId: curFirstLevel.value.id,
      submenuId: data.id,
    },
  });
};

// 重置文档内容
const resetDocData = () => {
  currentdetail.value = {};
  curSecondLevel.value = {};
  contentNav.value = [];
  nextdetail.value = {};
  previousdetail.value = {};
};

//根据id获取文章
const getdocumentDeatail = async () => {
  loaded.value = false;
  currentNodeKey.value = documentId.value;
  await resourceDetail({
    documentDetailId: documentId.value,
    keyword: "",
  })
    .then((res) => {
      if (res.code === 200) {
        let {
          currentDocumentDetail,
          previousDocumentDetail,
          nextDocumentDetail,
        } = res.result;
        const newHdomList = setElementId(currentDocumentDetail.contentDetail);
        currentDocumentDetail.contentDetail = newHdomList;
        currentdetail.value = currentDocumentDetail;
        contentNav.value = getContentDirTree(newHdomList);
        nextdetail.value = nextDocumentDetail;
        previousdetail.value = previousDocumentDetail;
      }

      // 设置代码块高亮
      setTimeout(() => {
        prism.highlightAll();
      }, 0);
      loaded.value = true;
    })
    .catch((err) => {
      console.log(err);
      loaded.value = true;
    });
};

// 根据文章生成文档导读
const getContentDirTree = (htmlData) => {
  if (!htmlData) {
    return [];
  }
  let hDomList = htmlData.match(/<h[1-3]{1}[^>]*>([\s\S]*?)<\/h[1-3]{1}>/g);
  if (!Array.isArray(hDomList)) {
    return [];
  }
  const dirTree = [];
  let preDir;
  hDomList.forEach((hDom, index) => {
    const startIndex = hDom.indexOf('id="');
    const endIndex = hDom.indexOf('">');
    if (startIndex != -1 && endIndex != -1) {
      const domId = hDom.slice(startIndex + 4, endIndex);
      const re = /<h([1-3]{1})[^>]*>([\s\S]*?)<\/h[1-3]{1}>/;
      let hLevel = Number(hDom.replace(re, "$1"));
      let titleContent = hDom.replace(re, "$2");
      // 去掉h标签内的标签
      let title = titleContent.replaceAll(/<([\s\S]*?)>|<\/([\s\S]*?)>/g, "");
      if (route.query.key) {
        title = title.replaceAll(
          route.query.key,
          `<span style="color: #F43F31;">${route.query.key}</span>`
        );
      }
      const currentDir = {
        id: index + 1, //用于点击的时候选中态
        title,
        domId,
        hLevel,
      };
      if (preDir) {
        if (currentDir.hLevel === 1) {
          currentDir.pid = 0;
        } else if (currentDir.hLevel > preDir.hLevel) {
          currentDir.pid = preDir.id;
        } else if (currentDir.hLevel < preDir.hLevel) {
          const pLevel = currentDir.hLevel === 1 ? 1 : currentDir.hLevel - 1;
          const pDir = dirTree.filter((item) => item.hLevel === pLevel);
          currentDir.pid = pDir[pDir.length - 1].id;
        } else {
          currentDir.pid = preDir.pid;
        }
      } else {
        currentDir.pid = 0;
      }
      preDir = currentDir;
      dirTree.push(currentDir);
    }
  });
  hDomIdList.value = dirTree;

  dirTree.forEach((item) => {
    if (item.pid !== 0) {
      const findParent = dirTree.find((i) => i.id === item.pid);
      if (findParent) {
        if (!Array.isArray(findParent.children)) {
          findParent.children = [];
        }
        findParent.children.push(item);
      }
    }
  });
  return dirTree.filter((i) => i.pid === 0);
};

const setScrollPosition = (e, data) => {
  e.preventDefault();
  clearTimeout(scrollTimeout.value);
  scrollTimeout.value = null;
  window.removeEventListener("scroll", handleScroll);
  browsePosition.value = data.domId;
  const hashEl = document.getElementById(data.domId);
  if (hashEl) {
    hashEl.scrollIntoView({ behavior: "smooth" });
  }
  scrollTimeout.value = setTimeout(() => {
    window.addEventListener("scroll", handleScroll);
  }, 1200);
};

// 获取图片
const getImg = (e) => {
  if (
    e.target.localName === "img" &&
    e.target.currentSrc &&
    e.target.currentSrc !== ""
  ) {
    previewImgRef.value.openPreview(e.target.currentSrc);
  }
};

// 上一篇/下一篇
const toNextPage = (data) => {
  if (!data.id) return;
  documentId.value = data.id;
  // 提前赋值,避免滚动条闪烁
  currentdetail.value = data;
  router.replace({
    path: "/downloads",
    query: {
      menuId: curFirstLevel.value.id,
      submenuId: curSecondLevel.value.id,
      docId: documentId.value,
    },
  });
  setTimeout(() => {
    getdocumentDeatail();
  });
};

// 点击面包屑
const clickBreadcrumbs = (type) => {
  // 一级
  if (type == 1) {
    currentNodeKey.value = "";
    resetDocData();
    getProjectMenu();
    router.replace({
      path: "/downloads",
      query: {
        menuId: curFirstLevel.value.id,
      },
    });
  }

  // 二级
  if (type === 2) {
    if (curSecondLevel.value.children) {
      documentId.value = curSecondLevel.value.children[0].id || "";
    }
    router.replace({
      path: "/downloads",
      query: {
        menuId: curFirstLevel.value.id,
        submenuId: curSecondLevel.value.id,
        docId: documentId.value,
      },
    });
  }

  getdocumentDeatail();
};

onMounted(() => {
  // getResProjectList();
  getMyInfo()
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style lang="scss" scoped>
.out-bg{
  width: 100%;
  min-height: 100vh;
  background-color: #f8f8f8;
}
.resource-center-container {
  width: 100%;
  min-height: calc(100vh - 56px - 40px);
  padding-bottom: 40px;
  background-color: #f8f8f8;
  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .no-content {
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .txt {
      color: #333;
      font-size: 14px;
      line-height: 28px;
      opacity: 0.4;
    }
  }

  .page-no-data {
    width: 100%;
    height: calc(100vh - 56px - 40px);
    .page-no-data-main {
      height: calc(100% + 40px);
      padding: 24px 0;

      .no-content {
        background: #ffffff;
        height: 100%;
        margin: 0 auto;
        width: calc(462px + 64.5%);
        max-width: 90%;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          margin-top: -40px;
        }
      }
    }
  }

  .resource-main {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 56px - 64px - 20px - 40px);
    .left-catelog {
      width: 208px;
      min-height: 100%;
      margin-right: 16px;
      border-radius: 4px;
      background: #ffffff;
      padding-bottom: 40px;

      .main-title {
        font-size: 20px;
        line-height: 28px;
        text-align: left;
        margin: 16px;
        word-wrap: break-word;
        word-break: normal;
      }
    }
    .resource-content {
      width: 64.5%;
      padding-bottom: 88px;
      background: #ffffff;
      position: relative;
      .main {
        padding: 16px 24px 36px;
      }
      .breadcrumbs {
        display: flex;
        align-items: center;
        .crumbs-item {
          max-width: 200px;
          font-size: 12px;
          line-height: 17px;
          color: #666666;
        }
        .crumbs-active {
          color: #386aea;
          cursor: pointer;
        }
        .next-btn {
          margin: 0 4px;
          width: 4px;
          height: auto;
          background: #ffffff;
        }
      }

      .document-title {
        font-size: 24px;
        line-height: 34px;
        color: #333333;
        margin-top: 24px;
      }
      .create-time {
        margin-top: 16px;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: auto;
        }
        .times {
          margin-left: 4px;
          font-size: 12px;
          line-height: 17px;
          color: #666666;
        }
      }
      .documnet-content {
        margin-top: 32px;
        font-size: 14px;
        overflow: hidden;

        ::v-deep {
          h1 {
            font-size: 20px;
            line-height: 40px;
            color: #333333;
            margin-bottom: 16px;
            word-break: break-word;
          }
          h2 {
            font-size: 18px;
            line-height: 36px;
            color: #333333;
            margin-bottom: 16px;
            word-break: break-word;
          }
          h3 {
            font-size: 16px;
            line-height: 32px;
            color: #333333;
            margin-bottom: 16px;
            word-break: break-word;
          }
          h4,
          h5,
          h6 {
            font-size: 14px;
            line-height: 32px;
            color: #333333;
            margin-bottom: 24px;
            word-break: break-word;
          }
          p {
            line-height: 24px;
            color: #333333;
            padding: 0;
            margin: 0;
            margin-bottom: 16px;
          }

          // 配置说明文字
          .code-toolbar + p {
            /* 添加样式，例如修改颜色或边框 */
            margin-top: -10px;
          }

          div[data-w-e-type="video"] + p {
          }

          table + p {
            margin-top: 4px;
          }

          :is(p):has(> img) + p {
            margin-top: -20px;
          }

          span {
            display: inline-block;
            line-height: inherit;
          }

          p[style*="text-indent"] > span {
            padding-right: 24px;
          }

          p[style*="text-indent"] span span {
            text-indent: 0;
          }

          p:has(a) span {
            display: inline;
            padding: 0!important;
          }

          table,
          tr,
          td,
          th {
            caret-color: transparent !important;
          }
          th {
            text-align: center;
            font-weight: bold;
            padding: 12px 0 11px;
          }
          th,
          tr,
          td {
            color: #333333;
            border: 1px solid #e9e9e9;
            line-height: 28px;
          }
          td {
            padding: 12px;
            width: transparent !important;
            &:first-child {
              padding-left: 16px;
            }
          }

          td:not([style*="width: auto"]) {
            /* 添加你想要的样式 */
            width: calc(100% + 24px);
          }

          tr:nth-child(2n + 1) {
            background: #f8f8f8;
          }
          img {
            max-width: 100% !important;
            height: auto !important;
            cursor: pointer;
          }
          li span {
            display: inline;
          }
          blockquote {
            background: rgba(56, 106, 234, 0.08);
            padding: 12px 16px 16px 24px;
            position: relative;
            color: #333333;
            line-height: 28px;
            margin-bottom: 36px;
            border-radius: 4px;
            &::before {
              content: "";
              width: 8px;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              border-radius: 4px 0 0 4px;
              background: rgba(56, 106, 234, 0.8);
            }
          }
          .code-toolbar {
            padding-top: 26px;
            margin: 0.5em 0 1em;
            border-radius: 4px;
            overflow: hidden;
            background-color: #f8f8f8;
            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 26px;
              background: #e9e9e9;
              border-radius: 4px 4px 0 0;
            }
            &::after {
              content: "";
              position: absolute;
              left: 0;
              top: 26px;
              width: 100%;
              height: 0.5em;
              background: #f8f8f8;
            }
            & > .toolbar {
              opacity: 1;
              top: 0.2em;
            }
            .copy-to-clipboard-button {
              box-shadow: none;
              color: #666666;
              font-size: 12px;
              padding-right: 26px;
              position: relative;
              &:hover {
                color: #666666;
              }
              &::after {
                content: "";
                width: 18px;
                height: 18px;
                position: absolute;
                top: 0px;
                right: 6px;
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHxSURBVHgB7ZnPbcIwFMZfogDiwgRlAgZAdIEu0KZnqvDvwKGwQDsDB/4UiROH0k7QBWgHYAJYACQEHIB+bkPL0YlfUCK938UOim2++NmWv0ckCIIgCIJwKSxipF6vu4fDoUSM2La9tCxr1u1234K0YxPWaDTy+/3+k6JjMhgMHnVftokJx3GWKFYUHS4i4kb3ZdZQLJfL+UwmwxqKfmi7/uMrZq2l084hRkaj0RzFnBjBLClxbtB2oYV5nndFjGSz2VWn02EL5cDCqtVqG7uUdzwec8TIbrejWq02S6fTDxC4IEMCbR4Y+BlFi1vUCfRbgMCvSqVSIEO0Z8zfzr2zn1aYuSUxAVH5Ux39qg94SwZoC8MCvjt7DHSm6KB21FQq9YGqioZSs9nMmay5UOcYvijrzqdQOyr6/ROy2WyMwp3tgI4bIixpiLCkIcKShghLGiIsaYiwpBF7Ybh4Tunf/Zrqtou9MHWdWa/XRdwHi7gDapumrC5VVIzHYzVjgS6dssaSRlhrICqXiq1f7TWmMh4Y+KeOhXwPK47Vp0ff1/Rr5Cjmw+HQyFvUFgYHabrdbhcQqBzgHP5ImyICY0zIkEBJCWWRIavy7ouLBOTDXnq93hMZEirbotI5yrUlRtCfMmBn/X5f+xAWBEEQBEGIB9880aVZYAsH0AAAAABJRU5ErkJggg==);
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
          }
        }
      }
    }
    .right-navigation-wrap {
      position: relative;
      width: 254px;
    }
    .right-navigation {
      margin-left: 16px;
      position: sticky;
      top: 80px;

      .main-title {
        font-size: 16px;
        line-height: 22px;
        margin: 80px 0 16px;
      }

      /* 四行溢出显示省略号*/
      .des_four_row {
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          -webkit-line-clamp: 4 !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          word-break: break-word;
          // text-align: justify;

      }
      .navigation-wrap {
        height: 336px;
        overflow-x: hidden;
        overflow-y: auto;
        direction: rtl;
        padding-left: 16px;
        .level1 {
          direction: ltr;
          .nav-item {
            a {
              cursor: pointer;
              font-size: 14px;
              line-height: 28px;
              color: #666666;
              text-decoration: none;
              transition: all 0.3s;
            }
          }
          .level1-item {
            .level1-title {
              display: block;
              font-size: 16px;
              line-height: 32px;
              color: #333333;
              padding: 0 0 8px 0;
            }
          }
          .level2-item {
            .level2-title {
              display: block;
              margin: 0 0 4px 16px;
            }
          }
          .level3-item {
            .level3-title {
              display: block;
              margin: 0 0 4px 32px;
            }
          }
          .nav-item .active-nav {
            text-decoration: underline;
            color: #386aea;
          }
        }
      }
      ::v-deep {
        /* 滚动条轨道样式 */
        ::-webkit-scrollbar {
          width: 6px; /* 设置滚动条宽度 */
        }

        /* 滚动条滑块样式 */
        ::-webkit-scrollbar-thumb {
          background-color: #386aea; /* 设置滑块背景颜色 */
          border-radius: 5px; /* 设置滑块圆角 */
        }

        ::-webkit-scrollbar-track {
          background: #e9e9e9;
          border-radius: 5px;
        }
      }
    }
  }

  .resource-content-download {
    width: calc(64.5% + 254px);
  }

  .resource-no-content {
    width: calc(64.5% + 254px);
    background: #ffffff;
  }

  ::v-deep {
    .el-tree-node__content > .el-tree-node__expand-icon {
      margin-left: 6px;
    }
    .el-tree-node__expand-icon:not(.is-leaf) {
      color: #333333;
    }
    .el-tree-node__label {
      color: #333333;
      white-space: normal;
      word-break: break-word;
      font-weight: bold;
      font-size: 12px;
      padding-right: 16px;
    }
    .el-tree-node__children .el-tree-node__label {
      font-weight: normal;
    }
    .el-tree-node__children {
      .el-tree-node__content {
        padding-left: 0 !important;
      }
    }
    .el-tree-node__content {
      padding: 12px 0;
      height: auto;
    }

    .el-tree-node__children {
      .el-tree-node__content {
        padding: 8px 0;
        height: auto;
      }
    }

    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
      background: #ffffff;
    }

    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
      .el-tree-node__label {
      color: #386aea;
      white-space: normal;
    }
  }

}
</style>
